if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){


      // Remove empty <p> tags created by tinymce
     const paragraph = document.querySelectorAll('p') || [];
	 paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

    const BREAK_MD = 900;

    $('.sym-slides').slick({
        accessibility: false,
        autoplay:true,
		autoplaySpeed: 4000
    });
    $('.sym-slides-list').slick({
        accessibility: false,
        autoplay:true,
		arrows:true,
		autoplaySpeed: 6500,
        speed: 1000,
        pauseOnHover:false
    });
	
    $('.gallery-block__list').slick({
		slidesToShow: 3,
        slidesToScroll: 1,
        centerMode: true,
		arrows:true,
		autoplay:true,
		accessibility: false,
		responsive: [
			{
			  breakpoint: 600,
			  settings: {
				arrows:false,
				dots:true,
				slidesToShow:1
			  }
			}
		]
    });

    $('.columns-mobile-slider').slick({
		slidesToShow: 1,
        slidesToScroll: 1,
		dots:true,
		arrows:false,
		autoplay:false,
		accessibility: false,
    });

    $('.reviews').slick({
        fade: true,
        accessibility: false,
        autoplay:true
    })

	document.addEventListener("DOMContentLoaded", function(event) { 

        let navegationLinks = document.querySelectorAll('.information-tabs__text');
		  
		$('.information-tabs__imagen--img').hide();
		$('.information-tabs__imagen--img:first').show();
		$('.information-tabs__imagen--img:first').addClass('active');
		$('.information-tabs__item:first').addClass('active');
        //Section enter the first item and show text
        navegationLinks.forEach((item, index) =>{
            index !=0 ? item.classList.add('hidden'): ''
        })
		$('.information-tabs__nav > li').click(function(event) {
            //Section enter and compare atribute target and show the text information
            let itemTarget = this.getAttribute('data-target').split('#')[1];
            navegationLinks.forEach((item) =>{
                item.classList.add("hidden");
                let target = item.getAttribute('data-info');
                itemTarget == target ? item.classList.remove('hidden'):''
            })

            $('.information-tabs__item').removeClass('active');
            $(this).addClass('active');

            $('.information-tabs__imagen--img').hide();
            var selectTab = $(this).attr("data-target");
            $(selectTab).fadeIn();
		});
	}());


	function scrollW(){
		//check scroll down or up for header styles
		let st = window.pageYOffset || document.documentElement.scrollTop;
		let header = document.getElementById('header');
		if(st > 80){
			if (st > lastScrollTop){
				// downscroll code
				if(!header.classList.contains('down')){
					header.classList.add('down');
					header.classList.remove('up');
				}
		 	 } else {
				// upscroll code
				if(!header.classList.contains('up')){
					header.classList.add('up');
					header.classList.remove('down');
				}
			}
		} else {
			if(header.classList.contains('up') || header.classList.contains('down')){
				header.classList.remove('up');
				header.classList.remove('down');
			}
		}
	
		let SubMenu = document.getElementById('subMenuAnchor');
		if(SubMenu){
			let subPost = document.getElementById('subMenu');
			let subPosition = '';
			if(document.body.classList.contains('alert_open')){
				subPosition = offset(SubMenu).top - 180;
			} else {
				subPosition = offset(SubMenu).top - 140;
			}
			if(st > subPosition){
				if(!subPost.classList.contains('floating-up')){
					subPost.classList.add('floating-up');
				}
			} else {
				if(subPost.classList.contains('floating-up')) {
					subPost.classList.remove('floating-up');
				}
			}
		}
	
		lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
	}





    	// * Slider to project with library "Slick"
	const SLIDER_SELECTOR$1 = '[data-tb-slick="home"]';
	const SLIDER_SELECTOR$2 = '[data-tb-slick="slider-block"]';
	const SLIDER_SELECTOR$3 = '[data-tb-slick="slider-tabs-block"]';
	const SLIDER_SELECTOR$4 = '[data-tb-slick="reviews-block"]';
	const SLIDER_SELECTOR$5 = '[data-tb-slick="timeline-block"]';
	const SLIDER_SELECTOR$6 = '[data-tb-slick="rooms-block"]';
	const SLIDER_SELECTOR$7 = '[data-tb-slick="location-block"]';
	const SLIDER_SELECTOR$8 = '[data-tb-slick="gallery-block"]';
	const SLIDER_SELECTOR$9 = '[data-tb-slick="mobile-slider-tabs-block"]';
	const SLIDER_SELECTOR$10 = '[data-tb-slick="list-featured"]';

	const SLIDER_SPEED$1 = 2000;


    const slickRooms = () => {
		let slickElements = document.querySelectorAll(SLIDER_SELECTOR$6);

		slickElements.forEach((element) => {
			let arrowsElement =
				element.dataset.tbSlickArrows !== undefined
					? element.dataset.tbSlickArrows
					: "#box-arrow";
			let arrowsBox = document.querySelector(arrowsElement);

			let dotsElement =
				element.dataset.tbSlickDots !== undefined
					? element.dataset.tbSlickDots
					: "#box-dots";
			let dotsBox = document.querySelector(dotsElement);

			$(element).slick({
				lazyLoad: "progressive",
				fade: true,
				cssEase: "cubic-bezier(0.7, 0, 0.3, 1)",
				arrows: true,
				dots: false,
				autoplay: false,
				appendArrows: arrowsBox,
				responsive: [
					{
						breakpoint: BREAK_MD,
						settings: {
							arrows: false,
							dots: true,
							appendDots: dotsBox,
						},
					},
				],
			});
		});
	};


	slickRooms()


})();